import React from "react";
import Icon from "./icons/Icon";
import getFavItems from "./utils/getFavItems";
import {createRoot} from "react-dom/client";

export default () => {
    const icons = document.querySelectorAll('[data-favbtn]');
    if (icons.length) {
        getFavItems().then((data) => {
            for (const icon of icons) {
                const itemRoot = createRoot(icon);
                itemRoot.render(
                    <Icon
                        product={parseInt(icon.getAttribute('data-favbtn'))}
                        added={parseInt(icon.getAttribute('data-added'))}
                    />
                );
            }
        })
    }
}
